import React, { useEffect, useState } from "react";
import "./UserLatestScoresTable.css";

function LatestPersonalityScoresTable() {
  const [scores, setScores] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_BACKEND_FLASK_API_URL}/admin/users/personality-latest`,
      {
        method: "GET",
        credentials: "include",
      }
    )
      .then((res) => res.json())
      .then((data) => setScores(data))
      .catch((err) => console.error("Error fetching scores:", err));
  }, []);

  const sortData = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });

    const sorted = [...scores].sort((a, b) => {
      let valA = a[key];
      let valB = b[key];

      // Force numerical sort if values are numbers
      if (["Extraversion", "Agreeableness", "Conscientiousness", "Emotional Stability", "Intellect/Imagination"].includes(key)) {
        valA = Number(valA) || 0;
        valB = Number(valB) || 0;
        return direction === "asc" ? valA - valB : valB - valA;
      }

      // Otherwise do string sort
      valA = valA?.toString().toLowerCase() || "";
      valB = valB?.toString().toLowerCase() || "";
      return direction === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    });

    setScores(sorted);
  };

  const renderSortArrow = (column) => {
    if (sortConfig.key === column) {
      return sortConfig.direction === "asc" ? " ▲" : " ▼";
    }
    return "";
  };

  return (
    <div className="quiz-questions-table">
      <div className="table-header">
        <h3>Latest Personality Scores of Users</h3>
      </div>
      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th onClick={() => sortData("username")}>
                Username{renderSortArrow("username")}
              </th>
                <th onClick={() => sortData("Extraversion")}>
                Extraversion{renderSortArrow("Extraversion")}
                </th>
                <th onClick={() => sortData("Agreeableness")}>
                Agreeableness{renderSortArrow("Agreeableness")}
                </th>
                <th onClick={() => sortData("Conscientiousness")}>
                Conscientiousness{renderSortArrow("Conscientiousness")}
                </th>
                <th onClick={() => sortData("Emotional Stability")}>
                Emotional Stability{renderSortArrow("Emotional Stability")}
                </th>
                <th onClick={() => sortData("Intellect/Imagination")}>
                Intellect/Imagination{renderSortArrow("Intellect/Imagination")}
                </th>
            </tr>
          </thead>
          <tbody>
            {scores.map((score, index) => (
              <tr key={index}>
                <td>{score.username}</td>
                <td>{score["Extraversion"]}</td>
                <td>{score["Agreeableness"]}</td>
                <td>{score["Conscientiousness"]}</td>
                <td>{score["Emotional Stability"]}</td>
                <td>{score["Intellect/Imagination"]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LatestPersonalityScoresTable;
